
import { defineComponent } from "vue";

export default defineComponent({
  name: "CrmProjectPreview",
  props: {
    project: {
      type: Object,
      default: () => null,
    },
    isLinked: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["linkToProject", "navigateToMobiCRM"],
});
